const pages = [
  {
    path: '',
    name: 'vikflow',
    redirect: to => ({ name: 'front-atendimento', query: to.query }),
  },
  {
    path: '/front-atendimento',
    name: 'front-atendimento',
    component: () => import('@/pages/front-atendimento/FilasDeAtendimento.vue'),
    meta: {
      layout: 'content',
      id: 2018,
    },
  },
  {
    path: '/front-atendimento-agente',
    name: 'front-atendimento-agente',
    component: () => import('../pages/front-atendimento/AtendimentoTickets.vue'),
    meta: {
      layout: 'content',
      id: 1083,
    },
    props: route => ({
      filaId: parseInt(route.query.filaId, 10) || null,
      filaNome: route.query.filaNome,
      ticketProtocolo: route.query.ticketProtocolo,
    }),
  },
  {
    path: '/front-atendimento-gestor',
    name: 'front-atendimento-gestor',
    component: () => import('../pages/front-atendimento/AtendimentoTickets.vue'),
    meta: {
      layout: 'content',
      id: 1083,
    },
    props: route => ({
      filaId: parseInt(route.query.filaId, 10),
      filaNome: route.query.filaNome,
      isGestor: true,
      activeTab: parseInt(route.query.activeTab, 10),
      ticketProtocolo: route.query.ticketProtocolo,
    }),
  },
  {
    path: '/dashboard-fila',
    name: 'dashboard-fila',
    component: () => import('@/pages/dashboard/DashboardFila.vue'),
    meta: {
      layout: 'content',
      id: 2028,
    },
  },
  {
    path: '/dashboard-equipe',
    name: 'dashboard-equipe',
    component: () => import('@/pages/dashboard/DashboardEquipe.vue'),
    meta: {
      layout: 'content',
      id: 2058,
    },
  },
  {
    path: '/dashboard-runtime',
    name: 'dashboard-runtime',
    component: () => import('@/pages/dashboard/DashboardRunTime.vue'),
    meta: {
      layout: 'content',
      id: 2058,
    },
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import('@/pages/faq/Faq.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/relatorio-bot',
    name: 'relatorio-bot',
    component: () => import('@/pages/relatorio/RelatorioBot.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/relatorio-equipe',
    name: 'relatorio-equipe',
    component: () => import('@/pages/relatorio/RelatorioEquipe.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/relatorio-fila',
    name: 'relatorio-fila',
    component: () => import('@/pages/relatorio/RelatorioFila.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/relatorio-sla',
    name: 'relatorio-sla',
    component: () => import('@/pages/relatorio/RelatorioSla.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/relatorio-envio-em-massa',
    name: 'relatorio-envio-em-massa',
    component: () => import('@/pages/relatorio/RelatorioEnvioEmMassa.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/clientes',
    name: 'clientes',
    component: () => import('@/pages/cliente/ClienteList.vue'),
    meta: {
      layout: 'content',
      id: 1059,
    },
  },
  {
    path: '/agendamentos-envio-mensagens',
    name: 'agendamentos-envio-mensagens',
    component: () => import('@/pages/envio-em-massa/agendamentos-envio-mensagens/AgendamentosEnvioMensagensList.vue'),
    meta: {
      layout: 'content',
      id: 1059,
    },
  },
  {
    path: '/canais',
    name: 'canais',
    component: () => import('@/pages/canal/CanalList.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/grupos-contatos',
    name: 'grupos-contatos',
    component: () => import('@/pages/envio-em-massa/grupos-contatos/GruposContatosList.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/templates-email',
    name: 'templates-email',
    component: () => import('@/pages/envio-em-massa/templates-email/TemplateEmailList.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/templates-email/:id',
    name: 'templates-email-detalhe',
    component: () => import('@/pages/envio-em-massa/templates-email/TemplateEmailView.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/equipes',
    name: 'equipes',
    component: () => import('@/pages/equipe/EquipeList.vue'),
    meta: {
      layout: 'content',
      id: 1084,
    },
  },
  {
    path: '/equipe/:id',
    name: 'equipe',
    component: () => import('@/pages/equipe/EquipeView.vue'),
    meta: {
      layout: 'content',
      id: 1085,
    },
  },
  {
    path: '/tipos-solicitacoes',
    name: 'tipos-solicitacoes',
    component: () => import('@/pages/tipo-solicitacao/TipoSolicitacaoList.vue'),
    meta: {
      layout: 'content',
      id: 1050,
    },
  },
  {
    path: '/tipo-solicitacao/:id',
    name: 'tipo-solicitacao',
    component: () => import('@/pages/tipo-solicitacao/TipoSolicitacaoView.vue'),
    meta: {
      layout: 'content',
      id: 1077,
    },
  },
  {
    path: '/filas',
    name: 'filas',
    component: () => import('@/pages/fila/FilasList.vue'),
    meta: {
      layout: 'content',
      id: 1058,
    },
  },
  {
    path: '/fila/:id',
    name: 'fila',
    component: () => import('@/pages/fila/FilaView.vue'),
    meta: {
      layout: 'content',
      id: 1058,
    },
  },
  {
    path: '/formularios',
    name: 'formularios',
    component: () => import('@/pages/formulario/FormularioList.vue'),
    meta: {
      layout: 'content',
      id: 2039,
    },
  },
  {
    path: '/formulario/:id',
    name: 'formulario',
    component: () => import('@/pages/formulario/FormularioView.vue'),
    meta: {
      layout: 'content',
      id: 2040,
    },
  },
  {
    path: '/chatbots',
    name: 'bots',
    component: () => import('@/pages/bots/BotsList.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/criar-chatbot',
    name: 'adicionar-bot',
    component: () => import('@/pages/bots/BotViewAddNew.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/chatbot/:id',
    name: 'bot',
    component: () => import('@/pages/bots/BotViewAddNew.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/pausas',
    name: 'pausas',
    component: () => import('@/pages/pausas/PausasList.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/atendente-disponibilidade',
    name: 'atendente-disponibilidade',
    component: () => import('@/pages/agenda/disponibilidade/Disponibilidade.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/minha-agenda',
    name: 'minha-agenda',
    component: () => import('@/pages/agenda/minha-agenda/index.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/tipos-agendamentos',
    name: 'tipos-agendamentos',
    component: () => import('@/pages/agenda/tipo-agendamento/TipoAgendamentoList.vue'),
    meta: {
      layout: 'content',
    },
  },
]

export default pages
